// src/app/core/interceptors/loader.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { LoaderService } from '@shared/services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  loaderService.show();

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          // You can handle successful responses if needed
        }
      },
      error: (error) => {
        if (error instanceof HttpErrorResponse) {
          // You can handle errors here if needed
        }
      },
    }),
    finalize(() => {
      loaderService.hide();
    })
  );
};
